import { connect } from 'react-redux'
import { withCurrentRoute } from '../../components/HOCComponents/withCurrentRoute'

import LoadingPageMapView from '../../components/PagesComponents/LoadingPageMapView'
import { areRequestsWithOverlayPending } from '@layers-frontend/commons/store/selectors/requests'
import { getIsAppReady } from '../../selectors/config'
import { SEARCH_VIEW, SEARCH_DELETED_VIEW, FIELDS_LIST_VIEW, LOADING_PAGE_VIEW } from '../../actions/viewmode'

const mapStateToPropsWithRoute = (state, props) => {
  const { currentLocation } = props

  // Only show loading overlay on main views, not on field views
  const isMainView = [SEARCH_VIEW, SEARCH_DELETED_VIEW, FIELDS_LIST_VIEW, LOADING_PAGE_VIEW].includes(currentLocation?.view)

  return {
    // Also while the viewer loads its data under a field opened from the dashboard.
    areRequestsPending: areRequestsWithOverlayPending(state) && (isMainView || !getIsAppReady(state))
  }
}

export default withCurrentRoute(connect(mapStateToPropsWithRoute)(LoadingPageMapView))
